import { keyframes, style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';
import { reducedMotion } from '@/shared/ui/theme/media';

/**
 * 후보 조건 줄 (퀘스트 7ca8908c) — 섭외 IA §3-3.
 *
 * 나라 칩 · 팔로워 범위 · 조회 단추가 폭 558 안에서 **한 줄**로 선다(퀘스트 2f546c56 B안). 상자를
 * 따로 두르지 않는다 — 두르면 테두리·안쪽 여백만 24px 를 더 먹고, 이 줄은 단계 줄 바로 아래라
 * 경계가 이미 서 있다.
 */
export const bar = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
});

/** 화면에는 안 보이고 이름만 준다 — 제목 없는 section 은 region 으로 안 읽히고, 칸에는 라벨이 있어야 한다. */
export const srOnly = style({
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
});

export const fields = style({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
});

/** 팔로워 범위는 줄 오른쪽으로 민다 — 나라 칩과 조건을 눈으로 가른다. */
export const range = style({
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.xs,
  marginLeft: 'auto',
});

export const label = style({
  fontSize: vars.typography.fontSize['2xs'],
  color: vars.typography.textColor.label,
});

export const input = style({
  width: '80px',
});

export const result = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
});

export const progress = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});

export const queryProgress = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
});

export const progressTrack = style({
  height: '2px',
  overflow: 'hidden',
  borderRadius: vars.spacing.borderRadius.sm,
  background: vars.surface.card.default,
});

const scan = keyframes({
  from: { transform: 'translateX(-100%)' },
  to: { transform: 'translateX(334%)' },
});

export const progressSegment = style({
  display: 'block',
  height: '100%',
  width: '30%',
  borderRadius: vars.spacing.borderRadius.sm,
  background: vars.bright.primary.default,
  animation: `${scan} ${vars.animation.duration.crawl} ${vars.animation.easing.linear} infinite`,
  '@media': {
    [reducedMotion]: {
      animation: 'none',
      transform: 'translateX(117%)',
    },
  },
});

export const elapsed = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  fontVariantNumeric: 'tabular-nums',
  color: vars.typography.textColor.secondary,
});

export const failed = style({
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.bright.status.error,
});
